import { FieldStore } from '@tom-ui/utils'
import { reaction } from 'mobx'
import { useEffect } from 'react'

export const useMutualCarrierTypeCleanup = (
  inbound: FieldStore<string>,
  outbound: FieldStore<string>,
) => {
  useEffect(() => {
    const disposeInbound = reaction(
      () => inbound.value,
      newValue => {
        if (
          newValue &&
          (outbound.error === 'fieldIsRequired' || outbound.error === 'cannotSelectBothUnknown')
        ) {
          outbound.setError(undefined)
        }
      },
    )

    const disposeOutbound = reaction(
      () => outbound.value,
      newValue => {
        if (
          newValue &&
          (inbound.error === 'fieldIsRequired' || inbound.error === 'cannotSelectBothUnknown')
        ) {
          inbound.setError(undefined)
        }
      },
    )

    return () => {
      disposeInbound()
      disposeOutbound()
    }
  }, [inbound, outbound])
}
